import React, { Dispatch, memo, SetStateAction, useEffect } from 'react';
import { StoryblokRichtext } from 'storyblok-rich-text-react-renderer';
import { Theme } from '../../../../interfaces/enums/Theme.enum';
import { LineItem } from '../../../../services/quote.interfaces';
import { withBlokWrapper } from '../../../BlokWrapper/BlokWrapper';
import QuoteCostBreakdownSectionContentItem from './QuoteCostBreakdownSectionContentItem';

interface QuoteCostBreakdownSectionContentProps {
  breakdown_subheading: string;
  lineItems: LineItem[];
  subtotal_title: string;
  subtotal_copy: StoryblokRichtext;
  subTotal: number;
  subtotalDiscountName?: string;
  subTotalDiscountAmount?: number;
  setDoesLineItemsIncludeLegalFees: Dispatch<SetStateAction<boolean>>;
}

export const getTemporaryTestValue = (apiKey: string): number => {
  switch (apiKey) {
    case 'vat':
      return 34.0;
    case 'searches-fee':
      return 30.6;
    case 'official-copies-fee':
      return 42.0;
    case 'land-registry-fee':
      return 45.0;
    case 'legal-fee':
      return 140.0;
    default:
      return 0;
  }
};

const QuoteCostBreakdownSectionContent: React.FC<
  QuoteCostBreakdownSectionContentProps
> = ({
  breakdown_subheading,
  lineItems,
  subtotal_title,
  subtotal_copy,
  subTotal,
  subtotalDiscountName,
  subTotalDiscountAmount = 0,
  setDoesLineItemsIncludeLegalFees,
}) => {
  const doesLineItemsIncludeLegalFees = lineItems.some(
    (lineItem) => lineItem.name === 'Legal fee'
  );

  useEffect(() => {
    setDoesLineItemsIncludeLegalFees(doesLineItemsIncludeLegalFees);
  }, []);

  return (
    <>
      {/*-- breakdown section --*/}
      <div className="space-y-6">
        {breakdown_subheading && (
          <h3 className="font-dm-sans font-bold text-xl">
            {breakdown_subheading}
          </h3>
        )}
        <ul className="space-y-6 border-b border-b-border/light pb-5">
          {lineItems.map((lineItem) => (
            <div key={lineItem.name}>
              <QuoteCostBreakdownSectionContentItem lineItem={lineItem} />
            </div>
          ))}
        </ul>
      </div>
    </>
  );
};

export default memo(
  withBlokWrapper(QuoteCostBreakdownSectionContent, Theme.LIGHT)
);
